module.exports = __webpack_public_path__ + "f46c2cbaffd1bd65185a9ba57af282be.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/user4-128x128.jpg
// module id = ./assets/images/user4-128x128.jpg
// module chunks = 1